import { render } from "./CardButton.vue?vue&type=template&id=59ba98f5&ts=true"
import script from "./CardButton.vue?vue&type=script&lang=ts"
export * from "./CardButton.vue?vue&type=script&lang=ts"

import "./CardButton.vue?vue&type=style&index=0&id=59ba98f5&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__